export class GenderType {
  private constructor(readonly name: string, readonly code: string) {}

  static all(): GenderType[] {
    return [
      new GenderType('男性', 'M'),
      new GenderType('女性', 'F'),
      new GenderType('その他', 'U'),
    ];
  }
}
